import { Const, PERMS, TOOLS } from "const";
import classnames from "classnames";
import { Link } from "react-router-dom";
import HelpInfo from "components/HelpInfo";
import { Utils } from "helpers/utils";
import { Switch, FormControlLabel } from '@mui/material';
import TextBox from "./TextBox";
import Select, { components } from 'react-select';
import { useEffect, useState } from "react";
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import { APIClient } from "api/apiCore";
import * as url from "api/urls"
import { tb_PermConfig } from "types";
import BackHeaderIcon from "./BackHeaderIcon";
import Loader from "./Loader";
import { useDialog } from "DialogProvider";
import AppSimpleBar from "./AppSimpleBar";

interface PermConfigProps {
	permName: string;
	permTitle: string;
	defaultAllow: boolean;
	canEdit: boolean;
	cssContainer: string;
}
const PermConfig2 = ({ permTitle, permName, defaultAllow, canEdit, cssContainer }: PermConfigProps) => {
	const { dispatch, useAppSelector } = useRedux();
	const storeData = createSelector(
		(state: any) => state.Settings,
		(state: any) => state.Profile2,
		(st, p2) => ({
			activeTool: st.activeTool,
			isAdmin: p2.isAdmin,
		})
	);
	const dialog = useDialog();
	const { activeTool, isAdmin } = useAppSelector(storeData);

	const [loading, setLoading] = useState<boolean>(false);
	const [permData, setPermData] = useState<any[]>([]);

	useEffect(() => {
		loadData();
	}, [permName]);

	const loadData = async () => {
		// console.log('LOAD_PERM_CONFIG2_BY_PERM_NAME of ' + permName);
		setLoading(true);
		new APIClient().fnPostForm(url.LOAD_PERM_CONFIG2_BY_PERM_NAME, { permName: permName })
			.then(rs => {
				// console.log('LOAD_PERM_CONFIG2_BY_PERM_NAME:', rs);
				setPermData(rs);
				setLoading(false);
			})
			.catch(er => {
				Utils.HandleException(er, true);
				setLoading(false);
			});
	}

	const onAddNew = async () => {
		if (canEdit) {
			const ok = await dialog.showPermConfig({ permName: permTitle, entryId: null, permKey: permName, defaultAllow: true });
			if (ok) {
				loadData();
			}
		}
	}

	const onEdit = async (entryId: number) => {
		const ok = await dialog.showPermConfig({ permName: permTitle, entryId: entryId, permKey: permName, defaultAllow: true });
		if (ok) {
			loadData();
		}
	}

	const onDelete = async (entryId: number) => {
		Utils.SweetConfirm("ต้องการลบสิทธิ์ที่เลือกใช่หรือไม่")
			.then(rs => {
				if (rs.isConfirmed) {
					new APIClient().fnPostForm(url.DEL_PERM_CONFIG2, { entryId: entryId })
						.then(rs => { loadData() })
						.catch(e1 => { Utils.HandleException(e1, true); })
				}
			})
			.catch(er => {
				Utils.HandleException(er, true);
			});
	}

	return (
		<div className="perm2-ctn-main">
			{loading && <Loader />}
			<AppSimpleBar className={cssContainer}>
				{permData.length <= 0 && (
					<div className="d-flex justify-content-between hover hand" onClick={onAddNew}>
						❗️ยังไม่กำหนดสิทธิ์ {canEdit ? "คลิ๊ก เพื่อเพิ่ม" : ""}
					</div>
				)}

				{permData.map((row: any) => {
					const userTypes = (row.userTypes ?? "").split('|').filter((x: any) => x != "" && x != "").map((x: any) => Utils.GetUserTypeText(x)).join(", ");
					const items = [userTypes, row.companies, row.divisions, row.departments, row.positions, row.userNames];
					const isAll = !items.some(x => x ? 1 : 0);
					const caption = ["ประเภท", "บริษัท", "ฝ่าย", "แผนก", "ตำแหน่ง", "พนักงาน"];
					return (
						<div className="d-flex justify-content-between hover hand">
							<div className="d-flex justify-content-start flex-grow-1">
								<div>
									<span className={classnames("fas fz-15 pt-0 pe-1", {
										"fa-check-circle text-success": row.allow,
										"fa-times-circle text-danger": !row.allow
									})}></span>
									{/* {row.allow ? (<span className="fas fa-check-circle text-success"></span>) : (<span className="fas fa-times-circle text-danger"></span>)} */}
								</div>
								<div onClick={() => onEdit(row.entryId)} className="flex-grow-1" >
									{isAll && (
										<div className="perm2-ctn" >
											<span className="perm2-cap" >พนักงาน</span>
											<span className="perm2-value">ทั้งหมด (รวม external)</span>
										</div>)}
									{items.map((item: any, idx: number) => {
										return item && (
											<div className="perm2-ctn" >
												<span className="perm2-cap" >{caption[idx]}</span>
												<span className="perm2-value">{item.replaceAll('|', ', ')}</span>
											</div>
										)
									})}
								</div>
							</div>
							<div className="">
								{canEdit && (<>&nbsp;&nbsp;<span className="fas fa-minus-circle text-danger hand fz-15" onClick={() => onDelete(row.entryId)}></span></>)}
								{canEdit && (<>&nbsp;&nbsp;<span className="fas fa-plus-circle text-primary hand fz-15" onClick={onAddNew}></span></>)}
							</div>
						</div>
					)
				}
				)}
			</AppSimpleBar>

		</div>
	);
}

export default PermConfig2;